import type { ProductEntry } from "@innoclouds/db";
import { useCardLibStore } from "@innoclouds/shared";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import type { IProduct } from "../../../views/cardProductPage/iCardProduct";

export const useCardStore = defineStore("card", () => {
	const router = useRouter();
	const route = useRoute();

	const cardStoreLib = useCardLibStore();

	const getInitialStateCard = () => ({
		openCard: null as IProduct | null,
	});

	const stateCard = ref(getInitialStateCard());

	const setCurrentCard = (card: IProduct | null) => {
		stateCard.value.openCard = card;
	};

	const takeCurrentCard = (id: ProductEntry["id"]) => {
		if (route.query.mode === "pdf") {
			router.push(`/${route.params.orgId}/product/${id}?mode=pdf`);
			return;
		}
		router.push(`/${route.params.orgId}/product/${id}`);
		cardStoreLib.isUpSale = false;
	};

	//Computed

	//Methods
	return {
		stateCard,
		setCurrentCard,
		takeCurrentCard,
	};
});
